var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM9.096 14.76l2.146 3.112 3.185-7.351a1 1 0 0 1 1.81-.055L20 17.88V4H4v15.76l3.45-5a1 1 0 0 1 1.646 0ZM9 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5.416 4.269L18.833 20H12.5l2.916-6.731Zm-7.143 3.82L10.28 20H6.264l2.009-2.91Z"
  })));
};
export default SvgImage;